<div
  *ngIf="isLoading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
  style="padding-top: 36px; padding-bottom: 36px"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando menús...</p>
</div>

<mat-dialog-content *ngIf="!isLoading">
  <h3
    style="font-weight: 600; font-size: 24px; line-height: 32px; color: #111827"
  >
    Asignar Menú a "{{ data.nombreServicio || '-' }}"
  </h3>

  <div
    mat-dialog-content
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-form-field appearance="outline">
      <mat-label>Menús</mat-label>
      <mat-select [(ngModel)]="infoMenu">
        <mat-option *ngFor="let menu of kitchenMenus" [value]="menu">
          {{ menu.nombreMenu }}
        </mat-option>
        <mat-option *ngIf="kitchenMenus?.length == 0">
          No hay menus disponibles
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button
      mat-raised-button
      style="background-color: #e95a1a; color: white"
      (click)="assignMenuToProductGroupedService()"
    >
      Guardar
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
